import React, { useState } from 'react';
import { Facebook, Instagram, Linkedin } from "lucide-react";
import { Link } from 'react-router-dom';
import LegalModal from './LegalModal';
const Footer = () => {
  // Current year for copyright
  const currentYear = new Date().getFullYear();
  
  // State for legal modals
  const [modalOpen, setModalOpen] = useState<'privacy' | 'terms' | null>(null);

  // List of navigation links
  const navLinks = [{
    id: 'home',
    label: 'Home',
    path: '/'
  }, {
    id: 'about',
    label: 'About Us',
    path: '/about'
  }, {
    id: 'services',
    label: 'Services',
    path: '/services'
  }, {
    id: 'portfolio',
    label: 'Portfolio',
    path: '/portfolio'
  }, {
    id: 'contact',
    label: 'Contact Us',
    path: '/contact'
  }];
  return <footer className="text-white pt-12 pb-6 bg-gray-900">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          <div>
            <h3 className="text-2xl font-bold mb-4">Samsons Enterprises FZC</h3>
            <p className="text-gray-200 mb-4">
              Leading Google-trusted virtual tour and 360° content creation agency based in UAE. Specializing in immersive virtual experiences that transform how businesses connect with their audiences.
            </p>
            <div className="flex space-x-2">
              <a href="https://www.facebook.com/share/1Ee7DTJWyG/" target="_blank" rel="noopener noreferrer" className="text-gray-200 hover:text-vista-light-green transition-colors inline-flex items-center justify-center min-h-11 min-w-11" aria-label="Facebook">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="text-gray-200 hover:text-vista-light-green transition-colors inline-flex items-center justify-center min-h-11 min-w-11" aria-label="X (Twitter)">
                <svg className="h-5 w-5 fill-current" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <a href="#" className="text-gray-200 hover:text-vista-light-green transition-colors inline-flex items-center justify-center min-h-11 min-w-11" aria-label="Instagram">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://www.linkedin.com/company/samsonsenterprises/" target="_blank" rel="noopener noreferrer" className="text-gray-200 hover:text-vista-light-green transition-colors inline-flex items-center justify-center min-h-11 min-w-11" aria-label="LinkedIn">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-1">
              {navLinks.map(link => <li key={link.id}>
                  <Link to={link.path} className="text-gray-200 hover:text-vista-light-green transition-colors inline-flex items-center min-h-11 py-2">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Info</h3>
            <address className="not-italic text-gray-200 space-y-2">
              <p className="font-bold text-vista-light-green">Samsons Enterprises FZC</p>
              <p>SPC Free Zone</p>
              <p>Sheikh Mohammed Bin Zayed Rd,</p>
              <p>Al Zahia, Sharjah,</p>
              <p>United Arab Emirates</p>
              <p className="mt-2">Email: hello@samsons.ae</p>
              <div className="space-y-1 mt-2">
                <p>Phone: +971 52 678 1501</p>
                <p>Phone: +971 50 246 7786</p>
                <p>Phone: +971 50 906 4786</p>
              </div>
            </address>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-6 mt-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-200 text-sm">
              &copy; {currentYear} Samsons Enterprises FZC. All rights reserved
              <Link
                to="/x/mg-profile"
                aria-hidden="true"
                tabIndex={-1}
                className="inline-block cursor-default select-none"
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                .
              </Link>
            </p>
            <div className="mt-4 md:mt-0">
              <ul className="flex space-x-2 text-sm text-gray-200">
                <li>
                  <button 
                    onClick={() => setModalOpen('privacy')}
                    className="hover:text-vista-light-green transition-colors inline-flex items-center min-h-11 px-2"
                  >
                    Privacy Policy
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => setModalOpen('terms')}
                    className="hover:text-vista-light-green transition-colors inline-flex items-center min-h-11 px-2"
                  >
                    Terms of Service
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      <LegalModal 
        isOpen={modalOpen !== null}
        onClose={() => setModalOpen(null)}
        type={modalOpen || 'privacy'}
      />
    </footer>;
};
export default Footer;